import { setTestCookies, removeTestCookies } from '@packages/abtesting';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { useCookies } from '@packages/utilities';
import { useEffect } from 'react';

export const UseAbTestingCookiesFromEpsFragment = graphql(/* GraphQL */ `
  fragment UseAbTestingCookiesFromEpsFragment on SearchResultBase {
    abTesting {
      newTestAssignments {
        testId
        participantId
        variant {
          attribute
          value
        }
      }
      expiredTestIds
    }
  }
`);

export const useAbTestingCookiesFromEps = (
  maskedData?: FragmentType<typeof UseAbTestingCookiesFromEpsFragment>,
) => {
  const { getCookies, setCookie, destroyCookie } = useCookies();
  const cookies = getCookies();

  const data = maskedData
    ? getFragmentData(UseAbTestingCookiesFromEpsFragment, maskedData)
    : undefined;

  useEffect(() => {
    const { newTestAssignments, expiredTestIds } = data?.abTesting ?? {};

    if (newTestAssignments) {
      newTestAssignments.forEach(({ testId, participantId: participant, variant }) => {
        setTestCookies({
          testId,
          cookies,
          setCookie,
          value: {
            participant,
            variant: Object.fromEntries(variant.map(({ attribute, value }) => [attribute, value])),
          },
        });
      });
    }

    if (expiredTestIds) {
      expiredTestIds.forEach((testId) => {
        removeTestCookies({ testId, removeCookie: destroyCookie });
      });
    }
  }, [data, cookies, destroyCookie, setCookie]);
};
